import type { EmployeeStatusHistoryTableViewModel } from 'ab-viewModels/employeeStatusHistoryTable.viewModel';

const CSV_HEADER_KEYS = [
	'Status',
	'Status Valid',
	'Unavailability Reason',
];

export const toCSVData = (viewModels: EmployeeStatusHistoryTableViewModel[]): string[][] => {
	const header: string[] = [...CSV_HEADER_KEYS];

	const rows: string[][] = viewModels.map((_entry: EmployeeStatusHistoryTableViewModel) => {
		const _row: string[] = [
			_entry?.status?.name ?? 'Available',
			_entry?.statusValidTo ? `from ${_entry?.statusValidFrom} to ${_entry?.statusValidTo}` : `from ${_entry?.statusValidFrom}`,
			_entry?.status?.available ? 'N/A' : _entry?.unavailabilityReason ?? 'None',
		];
		return _row;
	});

	return [header, ...rows];
};
